import App from "../Core/App";

export default class LayoutHelper {

    // is our page in collapsed / mobile view?
    static isCollapsedView() {
        return $('#blb-nav-toggle-btn').is(':visible')
    }

    // is page in Home Layout
    static isHome(){
        return $(".blb-box-container-home").length ? true : false;
    }

    // is the user-agent a mobile device?
    static isMobile(agent = "") {
        agent = agent.length > 0 ? agent : navigator.userAgent || navigator.vendor || window.opera;

        if( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(agent) 
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(agent.substr(0,4))) {

            return true;
        }

        return false;
    }

    static getCurrentLayout() {
        let layout = '';

        _.mapObject(this._fetchLayouts(), (val, key) => {
            if( window.innerWidth >= val[0] && window.innerWidth <= val[1] ) {
                layout = key;
                return;
            }
        });

        return layout == '' ? 'wide' : layout;
    }

    static getDimensionsByLayout(layout) {
        let list = this._fetchLayouts();

        if( list.hasOwnProperty(layout) ) {
            return list[layout];
        }

        return [];
    }

    // Check if element a overlaps element b
    static overlaps(a, b, ignorePadding = true, tolerance = {x:0,y:0}) {
        function comparePositions( p1, p2 ) {
            var leftX   = Math.max(p1[0].x, p2[0].x - tolerance.x),
                rightX  = Math.min(p1[1].x, p2[1].x + tolerance.x),
                topY    = Math.max(p1[0].y, p2[0].y - tolerance.y),
                bottomY = Math.min(p1[1].y, p2[1].y + tolerance.y);

            return leftX < rightX && topY < bottomY;
        }

        var pos1 = this._getElementRect( a, ignorePadding ),
            pos2 = this._getElementRect( b, ignorePadding );

        return comparePositions( pos1, pos2 );
    }

    // Check if element a is completely inside element b (return false) or overflows (return true)
    static overflows(a, b, ignorePadding = true, tolerance = {x:0,y:0} ) {
        let pos1 = this._getElementRect( a, ignorePadding ),
            pos2 = this._getElementRect( b, ignorePadding );

        return !( 
                (pos1[0].x >= (pos2[0].x - tolerance.x) && pos1[0].y >= (pos2[0].y - tolerance.y)) && 
                (pos1[1].x <= (pos2[1].x + tolerance.x) && pos1[1].y <= (pos2[1].y + tolerance.y)) 
                );
    }

    static _getElementRect( elem, ignorePadding = true ) {
        let pos     = $( elem ).offset(),
            width   = ignorePadding ? $( elem )[0].offsetWidth : $( elem )[0].clientWidth,
            height  = ignorePadding ? $( elem )[0].offsetHeight : $( elem )[0].clientHeight;

        return [ {'x': pos.left, 'y': pos.top}, {'x': pos.left+width, 'y': pos.top+height} ];
    }

    static _fetchLayouts() {
        let app = App.getInstance(),
            br  = app.getBreakpoints();

        return {
            'mobile': [br.xs, br.sm-1],
            'compact': [br.sm, br.lg-1],
            'wide': [br.lg, br.xl]
        };
    }
}